module.exports = __webpack_public_path__ + "img/aeroland-ebook-box-image-06.f5462a39.png";